import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import { styled } from "@mui/material";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import Guid from "_shared/guids/guid";
import { getIndividualsByUserIds } from "marketplace/individuals/_stores/individuals-redux-slice";
import Individual from "marketplace/individuals/individual";
import ViewIndividualProfile from "marketplace/individuals/profiles/_views/individual-profile-container";
import { useSelector } from "react-redux";
import TeamTemplate from "work/team-templates/team-template";
import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";


const TeamColumnLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.black,
  display: "block",
  textDecorationColor: theme.palette.common.black,
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
  float: "left",
  clear: "left"
}));


type MembersColumnCellProps = {
  teamTemplate?: TeamTemplate;
  teamUserIds?: Guid[];
  activeTeam?: VendorTeam;
};


export default function MembersColumnCell(props: Readonly<MembersColumnCellProps>) {
  const { teamTemplate, teamUserIds, activeTeam } = props;
  const { openDialog, closeDialog } = useDialog();

  let membersUserIds: Guid[] = [];

  if (activeTeam) {
    membersUserIds = activeTeam.members?.map((m) => m.userId) || [];
  } else if (teamTemplate) {
    membersUserIds = teamTemplate.members?.map((m) => m.userId) || [];
  } else if (teamUserIds) {
    membersUserIds = teamUserIds;
  }

  const teamIndividualsResponse = useSelector(getIndividualsByUserIds(membersUserIds));

  if (!teamIndividualsResponse || teamIndividualsResponse.length === 0) {
    return <Icon>remove</Icon>;
  }

  return (
    <div>
      {teamIndividualsResponse.map((individual: Individual) => (
        <TeamColumnLink
          key={individual.userId.value}
          onClick={(event) => {
            event.stopPropagation();
            openDialog({
              component: <ViewIndividualProfile profile={individual.profile} individualId={individual.id} />,
              contentSxProps: {
                display: "flex",
              },
              MuiProps: {
                fullWidth: true,
                maxWidth: "lg",
              },
              titleStyle: {
                paddingBottom: 0
              },
              onClose: closeDialog,
            });
          }}
        >
          {individual.profile.fullName}
        </TeamColumnLink>
      ))}
    </div>
  );
}